function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useCallback, useState } from 'react';
import { cloneDeep, set } from 'lodash';
import { applicationIdSelector, useLazyLoad, useReduxSelector } from '@applyboard/ab-common';
import { getApplicationSnapshotAction, createApplicationSnapshotAction } from "../../api/jsonapi";
import PresentationComponent from "./ApplicationSnapshot";
import useCurrentApplicationAsSnapshot from "./useCurrentApplicationAsSnapshot";
import getPath from "./getPath";
import applyDiff from "./applyDiff";
import { SaveButton } from "./style";
var ApplicationSnapshot = function ApplicationSnapshot() {
  var id = useReduxSelector(applicationIdSelector);

  // our version of babel does not currently support function generics
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    committedElements = _useState2[0],
    setCommittedElements = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    cachedSnapshot = _useState4[0],
    setCachedSnapshot = _useState4[1];
  var handleCommit = useCallback(function (key, commit) {
    if (commit) {
      setCommittedElements(function (state) {
        if (state.indexOf(key) >= 0) return state;
        return [].concat(_toConsumableArray(state), [key]);
      });
    } else {
      setCommittedElements(function (state) {
        return state.filter(function (element) {
          return element !== key;
        });
      });
    }
  }, [setCommittedElements]);
  var _useLazyLoad = useLazyLoad(getApplicationSnapshotAction, {
      id: id,
      snapshotId: 'latest'
    }),
    _useLazyLoad2 = _slicedToArray(_useLazyLoad, 2),
    data = _useLazyLoad2[0],
    request = _useLazyLoad2[1];
  React.useEffect(function () {
    setCachedSnapshot(data);
  }, [data]);
  var snapshot = React.useMemo(function () {
    return cachedSnapshot && cachedSnapshot.attributes;
  }, [cachedSnapshot]);
  var currentSnapshot = useCurrentApplicationAsSnapshot();
  var handleSaveData = useCallback(function () {
    var updatedValues = {};
    committedElements.forEach(function (path) {
      updatedValues[path] = getPath(path, currentSnapshot);
    });
    var clonedSnapshot = cloneDeep(snapshot);
    var compiled = applyDiff(clonedSnapshot, updatedValues);
    var _final = fixCorruptSnapshot(compiled);
    createApplicationSnapshotAction({
      id: id
    }, _final).then(function () {
      setCachedSnapshot({
        attributes: _final
      });
      setCommittedElements([]);
      alert('Successfully created snapshot');
    })["catch"](function () {
      alert('Error creating snapshot');
    });
  }, [snapshot, committedElements, setCachedSnapshot, setCommittedElements]);
  if (request && request.hasFailed) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, "Error!");
  }
  if (!snapshot || !currentSnapshot) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, "Loading...");
  }
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(SaveButton, {
    disabled: committedElements.length <= 0,
    onClick: handleSaveData
  }, "Save Changes"), /*#__PURE__*/React.createElement(PresentationComponent, {
    snapshot: snapshot,
    onCommit: handleCommit,
    committedKeys: committedElements,
    currentSnapshot: currentSnapshot
  }), /*#__PURE__*/React.createElement(SaveButton, {
    disabled: committedElements.length <= 0,
    onClick: handleSaveData,
    style: {
      marginTop: '4px'
    }
  }, "Save Changes"));
};

/**
 * This is a temporary workaround.  Adding required fields to the snapshot
 * validation causes all previously saved snapshots to break.
 *
 * Ideally we should fix corrupt snapshots with migrations or BE type coercion
 *
 * @see https://applyboard.atlassian.net/browse/AWA-3271
 * @see https://applyboard.atlassian.net/browse/AWA-4592
 */
function fixCorruptSnapshot(snapshot) {
  var _snapshot$programAppl, _snapshot$programAppl2, _snapshot$programAppl3, _snapshot$programAppl4, _snapshot$programAppl5, _snapshot$programAppl6, _snapshot$programAppl7, _snapshot$programAppl8, _snapshot$programAppl9;
  // validIrelandStudyVisaOrVisitorVisa, validAustraliaStudyVisaOrVisitorVisa, validUKStudyVisaOrVisitorVisa are required fields
  // We need to set them to false if they're missing, which can occur if we're saving changes to a snapshot created
  // before Feb 4th, 2022 (validIrelandStudyVisaOrVisitorVisa) or March 26, 2020 (validAustraliaStudyVisaOrVisitorVisa, validUKStudyVisaOrVisitorVisa)

  var fixedSnapshot;
  if (!(snapshot !== null && snapshot !== void 0 && (_snapshot$programAppl = snapshot.programApplication) !== null && _snapshot$programAppl !== void 0 && (_snapshot$programAppl2 = _snapshot$programAppl.applicant) !== null && _snapshot$programAppl2 !== void 0 && (_snapshot$programAppl3 = _snapshot$programAppl2.backgroundInformation) !== null && _snapshot$programAppl3 !== void 0 && _snapshot$programAppl3.validIrelandStudyVisaOrVisitorVisa)) {
    fixedSnapshot = set(cloneDeep(snapshot), 'programApplication.applicant.backgroundInformation.validIrelandStudyVisaOrVisitorVisa', false);
  }
  if (!(snapshot !== null && snapshot !== void 0 && (_snapshot$programAppl4 = snapshot.programApplication) !== null && _snapshot$programAppl4 !== void 0 && (_snapshot$programAppl5 = _snapshot$programAppl4.applicant) !== null && _snapshot$programAppl5 !== void 0 && (_snapshot$programAppl6 = _snapshot$programAppl5.backgroundInformation) !== null && _snapshot$programAppl6 !== void 0 && _snapshot$programAppl6.validAustraliaStudyVisaOrVisitorVisa)) {
    fixedSnapshot = set(cloneDeep(fixedSnapshot ? fixedSnapshot : snapshot), 'programApplication.applicant.backgroundInformation.validAustraliaStudyVisaOrVisitorVisa', false);
  }
  if (!(snapshot !== null && snapshot !== void 0 && (_snapshot$programAppl7 = snapshot.programApplication) !== null && _snapshot$programAppl7 !== void 0 && (_snapshot$programAppl8 = _snapshot$programAppl7.applicant) !== null && _snapshot$programAppl8 !== void 0 && (_snapshot$programAppl9 = _snapshot$programAppl8.backgroundInformation) !== null && _snapshot$programAppl9 !== void 0 && _snapshot$programAppl9.validUKStudyVisaOrVisitorVisa)) {
    fixedSnapshot = set(cloneDeep(fixedSnapshot ? fixedSnapshot : snapshot), 'programApplication.applicant.backgroundInformation.validUKStudyVisaOrVisitorVisa', false);
  }
  return fixedSnapshot || snapshot;
}
export default ApplicationSnapshot;